import {
  Modal,
  ModalFooter,
  ModalContent,
  ModalOverlay,
  ModalBody,
  ModalHeader,
  Button,
  Text,
  Flex,
  Spacer,
} from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { useUserData } from "@/contexts/UserDataContext";
import { LinkButton } from "../../shared/generic";
import { getDemandUserCost } from "@/utils/completeness/completenessScore";
import { hasEnoughCredits } from "@/utils/credits";

export function ModalUnlockSuccess({ open }) {
  const onClose = () => window.location.reload();

  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p={8} fontSize="3xl" fontFamily="heading" textAlign="center">
          Unlocked profile!
        </ModalHeader>
        <ModalBody>
          You now have access to full-length essays, awards, extracurricular activities, and more
          from this profile 1 year.
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="green" onClick={onClose} rightIcon={<ChevronRightIcon />}>
            Awesome!
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export function ModalUnlockProfile({ profile, header, onClose, onUnlock }) {
  const { userData } = useUserData();

  let customMessage = undefined;

  const creditCost = getDemandUserCost(profile);
  const preferBonusCredits = !!profile.eligible_for_free;

  if (userData.type === "college") {
    customMessage = {
      button: (
        <LinkButton
          size="lg"
          colorScheme="green"
          href="/plans"
          mt={4}
          rightIcon={<ChevronRightIcon />}
        >
          Explore Packages
        </LinkButton>
      ),
    };
  } else if (userData.type === "enterprise") {
    const enoughEnterpriseMoney = hasEnoughCredits(userData, creditCost, preferBonusCredits, true);

    if (!enoughEnterpriseMoney) {
      const enoughCredits = hasEnoughCredits(userData, creditCost, preferBonusCredits);

      if (enoughCredits) {
        customMessage = {
          message: (
            <Text mt={4}>
              You currently doesn't have enough enterprise unlocks to unlock this profile. You have{" "}
              <b>{userData.credits || 0}</b> purchased credits remaining. Ready to unlock a profile
              for <b>{creditCost}</b> credits?
            </Text>
          ),
          button: (
            <Button colorScheme="green" rightIcon={<ChevronRightIcon />} onClick={onUnlock} mt={4}>
              Unlock
            </Button>
          ),
        };
      } else {
        customMessage = {
          message: (
            <Text mt={4}>
              You currently doesn't have enough enterprise unlocks or credits to unlock this
              profile. You can get enterprise unlocks on the link below.
            </Text>
          ),
          button: (
            <LinkButton
              size="lg"
              colorScheme="green"
              rightIcon={<ChevronRightIcon />}
              href="/partnerships"
              mt={4}
            >
              Get Credits
            </LinkButton>
          ),
        };
      }
    } else {
      customMessage = {
        message: (
          <Text mt={4}>
            You currently have <b>{userData.enterprise_unlocks || 0}</b> enterprise unlocks and{" "}
            <b>{userData.credits || 0}</b> purchased credits remaining. Ready to unlock a profile
            for <b>{creditCost}</b> enterprise unlocks?
          </Text>
        ),
        button: (
          <Button colorScheme="green" rightIcon={<ChevronRightIcon />} onClick={onUnlock} mt={4}>
            Unlock
          </Button>
        ),
      };
    }
  } else if (userData.type === "hs") {
    // TODO: LOGIC HERE FOR PURCHASE
    if (!hasEnoughCredits(userData, creditCost, preferBonusCredits)) {
      customMessage = {
        message: (
          <Text mt={4}>You can get profile unlock credits for as cheap as $6 per profile!</Text>
        ),
        button: (
          <LinkButton
            size="lg"
            colorScheme="green"
            rightIcon={<ChevronRightIcon />}
            href="/plans"
            mt={4}
          >
            Get Credits
          </LinkButton>
        ),
      };
    } else {
      customMessage = {
        message: (
          <Text mt={4}>
            You currently have <b>{userData.bonusCredits || 0}</b> bonus credits and{" "}
            <b>{userData.credits || 0}</b> purchased credits remaining. Ready to unlock a profile
            for <b>{creditCost}</b> credits?
          </Text>
        ),
        button: (
          <Button colorScheme="green" rightIcon={<ChevronRightIcon />} onClick={onUnlock} mt={4}>
            Unlock
          </Button>
        ),
      };
    }
  } else {
    if (!!header) {
      header = "Get a free unlock!";
    }

    customMessage = {
      button: (
        <LinkButton
          colorScheme="green"
          size="lg"
          href="/plans"
          mt={4}
          rightIcon={<ChevronRightIcon />}
        >
          Claim my free unlock
        </LinkButton>
      ),
    };
  }

  return (
    <Modal onClose={onClose} isOpen={!!header}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p={8} fontSize="3xl" fontFamily="heading" textAlign="center">
          {header}
        </ModalHeader>
        <ModalBody fontSize="xl">
          <Text>
            Get full access to this student&apos;s personal statements, supplemental essays,
            activities, awards, advice, &amp; additional information.
          </Text>
          {customMessage.message}
        </ModalBody>
        <ModalFooter>
          <Flex>
            <Spacer />
            {customMessage.button}
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
